import { FiberManualRecord } from "@mui/icons-material";
import { Paper, styled } from "@mui/material";
import Calendar from "react-calendar";

export const StyledCalendar = {
  Calendar: styled(Calendar)(({ theme }) => ({
    boxShadow: "3px 3px 7px rgba(219,219,219,1)",
    width: "100% !important",
    borderRadius: "0px 0px 5px 5px",
    height: "auto",
    ".react-calendar__month-view__days__day": {
      maxHeight: "45px",
    },
  })),

  TileContentContainer: styled("div")({
    display: "flex",
    flexWrap: "wrap",
    gap: "0px",
    height: "100%",
    width: "100%",
    overflow: "visible",
    alignItems: "flex-start",
    justifyContent: "center",
  }),
  TileContent: styled("div")({
    padding: 2,
    paddingLeft: 9,
    paddingRight: 9,
    marginLeft: 1,
    marginRight: 1,
    borderRadius: 6,
    fontSize: 11,
    lineHeight: 1.1,
  }),

  ChipsRow: styled("div")(({ theme }) => ({
    display: "flex",
    flexWrap: "nowrap",
    gap: 4,
    alignItems: "center",
  })),
  MoreBadge: styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 18,
    height: 18,
    borderRadius: 8,
    backgroundColor: "#9e9e9e",
    color: "#fff",
    fontSize: 10,
    fontWeight: 600,
    lineHeight: 1,
    userSelect: "none",
    marginLeft: "1px",
  })),

  Loading: styled(Paper)({
    display: "flex",
    height: 250,
  }),

  State: styled("div")(({ theme, stateColor }) => ({
    backgroundColor: stateColor,
    color: "#ffffff",
  })),
};

export const StyledCalendarLabel = {
  Container: styled(Paper)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-around",
    borderRadius: 5,
  })),

  Label: styled("div")({
    display: "flex",
    alignItems: "center",
  }),

  Icon: styled(FiberManualRecord)(({ theme, stateColor }) => ({
    height: 15,
    width: 15,
    marginRight: 5,
    color: stateColor,
  })),
};
